import React, { memo, useState } from 'react';
import Link from 'next/link';

import {
  List,
  ListTitle,
  ListTitleContainer,
  SubList,
  SubListItem,
} from './styles';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { ICollapsibleMenuItem } from './model';
import { useTheme } from '@mui/material/styles';
import { ReleaseBadge } from '../release-badge';

export const CollapsibleMenuItem = memo<ICollapsibleMenuItem>(
  ({ title, items, closeDrawer }) => {
    const theme = useTheme();

    const [opened, setOpened] = useState(false);

    return (
      <List>
        <ListTitleContainer onClick={() => setOpened((state) => !state)}>
          <ListTitle opened={opened}>{title}</ListTitle>
          {opened ? (
            <ChevronUp
              size={20}
              color={theme.palette.secondary.main}
              style={{ marginLeft: 'auto' }}
            />
          ) : (
            <ChevronDown size={20} style={{ marginLeft: 'auto' }} />
          )}
        </ListTitleContainer>

        <SubList opened={opened}>
          {items?.map((item) => (
            <SubListItem key={item.link}>
              <Link
                href={item.link}
                title={item.label}
                rel="noopener"
                target="_blank"
                onClick={() => closeDrawer(true)}
              >
                {item.isRelease ? (
                  <ReleaseBadge>{item.label}</ReleaseBadge>
                ) : (
                  <>{item.label}</>
                )}
              </Link>
            </SubListItem>
          ))}
        </SubList>
      </List>
    );
  }
);
